var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_1089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.811 10.535L4.828 17.519L11.811 24.5C12.591 25.281 12.591 26.548 11.811 27.328C11.419 27.72 10.91 27.914 10.397 27.914C9.884 27.914 9.375 27.72 8.983 27.328L0.586 18.932C0.211 18.558 0 18.049 0 17.519C0 16.99 0.211 16.48 0.586 16.105L8.983 7.70698C9.764 6.92698 11.03 6.92698 11.811 7.70698C12.591 8.48798 12.591 9.75198 11.811 10.535ZM34.447 16.104L26.051 7.70598C25.27 6.92598 24.004 6.92598 23.223 7.70598C22.442 8.48698 22.442 9.75298 23.223 10.534L30.205 17.518L23.223 24.5C22.442 25.281 22.442 26.548 23.223 27.328C23.615 27.72 24.125 27.914 24.637 27.914C25.149 27.914 25.66 27.72 26.051 27.328L34.447 18.932C34.822 18.557 35.033 18.048 35.033 17.518C35.033 16.99 34.822 16.479 34.447 16.104ZM21.012 3.83098C19.936 3.55398 18.851 4.20398 18.577 5.27198L12.577 28.77C12.305 29.84 12.95 30.93 14.019 31.204C14.186 31.247 14.353 31.267 14.516 31.267C15.41 31.267 16.222 30.664 16.453 29.762L22.453 6.26398C22.727 5.19298 22.081 4.10398 21.012 3.83098Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_1089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.033,
    height: 35.033,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.b77ced797264139524a190df21c39934.svg";
export { ForwardRef as ReactComponent };